import React, { useContext, useEffect, useState } from 'react';
import { DataContext } from '../../utils/context';
const ContextProvider = (props) => {
    const { url, getParams, method, preProcess, dataSource, headers } = props;
    const [newData, setNewData] = useState();
    const { appHelper } = useContext(window.__appContext);
    const fetch = appHelper?.requestHandlersMap?.fetch || window?.lceFetch;
    useEffect(() => {
        const send = async () => {
            const res = await fetch({
                uri: url,
                method,
                params: typeof getParams === 'function' ? getParams() : {},
                headers,
            });
            setNewData(preProcess ? preProcess(res) : res);
        };
        if (!dataSource && url)
            send();
    }, [dataSource, url]);
    return (React.createElement(DataContext.Provider, { value: dataSource ?? newData }, props.children));
};
export default ContextProvider;
